import { matrixClone } from "./matrixClone.js";
/**
 * Numerically decodes the matrix using the dictionary.
 * @param matrixInitial
 * @param dictionary - dictionary against which to do the encoding
 * @returns - decoded matrix
 */
export function matrixNumericalDecoding(matrixInitial, dictionary) {
    const matrix = matrixClone(matrixInitial);
    const invertedDictionary = swap(dictionary);
    for (const row of matrix) {
        for (let j = 0; j < matrix[0].length; j++) {
            const value = row[j];
            if (typeof value === 'number' && value in invertedDictionary) {
                row[j] = invertedDictionary[value];
            }
        }
    }
    return matrix;
}
function swap(dictionary) {
    const ret = {};
    for (const key in dictionary) {
        ret[dictionary[key]] = key;
    }
    return ret;
}
//# sourceMappingURL=matrixNumericalDecoding.js.map